import React, { useState } from 'react';
import './Carousel.css';
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption, 
  Button
} from 'reactstrap';

import pic1 from "../../assets/pic1.jpg";
import pic2 from "../../assets/pic2.jpg";
import pic3 from "../../assets/pic3.jpg";

const items = [
  {
    src: pic1,
    altText: 'Slide 1',
    caption: <>
        <legend>ThothIT</legend>
        ThothIT is a leading professional IT and Technology consulting firm in 
        Florida that stands for innovation and quality.

        ThothIT offers full range of professional IT services including Consultation, 
        Application Development, System Integration, and many more to various national
        and international companies.

        Staffed with a highly dedicated team and experienced testing professionals, 
        ThothIT has helped enterprises and ISVs build quality software while improving 
        time-to-market and reducing cost of quality.
        <br/>
      <Button className="btnCarousel" outline href="/contact">CONTACT US</Button>
    </>
  },
  {
    src: pic2,
    altText: 'Slide 2',
    caption: <>
        <legend>Services</legend>
          ThothIT is fulfilling the ever-changing IT demands, by providing the right resource, 
          at the right place and at the right time. We provide cost-effective, task-oriented IT 
          resources to our clients. We strongly believe in giving more than 100% and working alongside 
          the clients.
      </>
  },
  {
    src: pic3,
    altText: 'Slide 3',
    caption: <>
        <legend>POSTS</legend>
        Welcome to the official website of ThothIT Consulting, a Florida-based firm providing IT staffing, 
        IT solutions and consulting services all over the United States.
      </>
  }
];

const Example = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  }

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  }

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  }

  const slides = items.map((item) => {
    return (        
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
        
      >
        <img src={item.src} className="carouselImg" alt={item.altText} />
        <CarouselCaption className="sliderContent d-block fade-in" captionText={item.caption} />
      </CarouselItem>
    );
  });

  return (
    <div>
      <Carousel
      className="carouselDiv"
      activeIndex={activeIndex}
      next={next}
      previous={previous}
      >
      <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
      {slides}
      <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
      <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
      </Carousel>
    </div>
  );
}

export default Example;
